<template>
  <vx-card class="upgrade-list vs-space-table">
    <paging-list
      :data="list"
      :total="total"
      :limit="query.limit"
      :page="query.page"
      @pageChange="onPageChange"
    >
      <div slot="header" class="top w-full">
        <slot name="helptext" />
        <vx-form class="vx-row">
          <form-item label="搜索" class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input class="w-full" placeholder="输入用户ID、昵称、手机号、邮箱" v-model="query.keyword"
                      @keypress.enter="fetchList(1)"/>
          </form-item>
          <form-item label="状态" class="vx-col sm:w-1/3 w-full mb-2">
            <v-select :options="statusOpts" v-model="query.status" :reduce="p => p.value"
                      @change="fetchList(1)"></v-select>
          </form-item>
          <form-item class="vx-col sm:w-1/3 w-full mb-2">
            <vs-button class="mr-3 mb-2" @click="fetchList(1)">
              查询
            </vs-button>
            <vs-button @click="$router.push({path: '/user/create', query: {roleID: roleID[0]}})" color="primary" type="border"
                       class="mb-4 mr-4 cursor-pointer items-center justify-between font-medium text-base text-primary border border-solid border-primary">
              <icon icon="PlusIcon" svgClasses="h-4 w-4" style="top: 2px"/>
              新建
            </vs-button>
          </form-item>
        </vx-form>
      </div>
      <template slot="thead">
        <vs-th>UID</vs-th>
        <vs-th width="100px" class="hidden sm:table-cell">头像</vs-th>
        <vs-th>用户名</vs-th>
        <vs-th>昵称</vs-th>
        <vs-th>角色</vs-th>
        <vs-th class="hidden md:table-cell">性别</vs-th>
        <vs-th>邮箱</vs-th>
        <vs-th class="hidden md:table-cell">更新时间</vs-th>
        <vs-th>操作</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{tr.uid}}</vs-td>
          <vs-td class="hidden sm:table-cell"><img class="avatar" :src="tr.avatarUrl"></vs-td>
          <vs-td class="whitespace-no-wrap">{{tr.userName}}</vs-td>
          <vs-td class="whitespace-no-wrap">{{tr.nickName}}</vs-td>
          <vs-td class="whitespace-no-wrap" v-if="$route.name !== 'user-channel'">{{$s.dict.roleName[tr.roleID]}}</vs-td>
          <vs-td class="whitespace-no-wrap" v-else>
            {{$s.dict.roleName[tr.roleID]}}
          </vs-td>
          <vs-td class="hidden md:table-cell">{{$s.dict.sex[tr.sex]}}</vs-td>
          <vs-td>{{tr.email}}</vs-td>
          <vs-td class="hidden md:table-cell">{{tr.createdAt | datetime}}</vs-td>
          <vs-td class="whitespace-no-wrap">
            <router-link :to="'/user/edit/' + tr.uid" v-if="$acl.check('user_edit')">编辑</router-link>
            <span class="text-warning ml-5 cursor-pointer" @click="resetUserPassword(tr)" v-if="$acl.check('user_edit')">重置密码</span>
            <span class="text-danger ml-5 cursor-pointer" @click="willRemove(tr)" v-if="$acl.check('user_edit')">删除</span>
          </vs-td>
        </vs-tr>
      </template>
    </paging-list>
  </vx-card>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        total: 0,
        query: {
          keyword: '',
          limit: 10,
          page: 1,
          status: 1,
        },
        statusOpts: [
          {
            label: '全部',
            value: 0,
          },
          {
            label: '正常',
            value: 1,
          },
          {
            label: '黑名单',
            value: 2,
          },
        ]
      }
    },
    computed: {
      roleID() {
        const routeName = this.$route.name
        const roleMap = {
          'user-admin': [2,1],
          'user-channel': [3,4],
          'user-user': [5],
        }
        return roleMap[routeName]
      }
    },
    watch: {
      $route() {
        this.list = []
        this.total = 0
        this.fetchList(1)
      }
    },

    methods: {
      onPageChange(p) {
        this.fetchList(p)
      },
      async fetchList(page) {
        if (page) {
          this.query.page = page
        }
        const q = {
          keyword: this.query.keyword,
          offset: (this.query.page - 1) * this.query.limit,
          limit: this.query.limit,
          status: this.query.status,
          roleID: this.roleID,
        }
        const {list, total} = await this.$s.user.fetchUser(q)
        this.list = list
        this.total = total
      },
      willRemove(item) {
        this.$confirm({
          color: 'danger',
          title: '确定删除该用户？',
          text: '删除后将不可恢复，是否确定',
          accept: async () => {
            await this.$s.user.remove(item.uid)
            this.list = this.list.filter(x => x.uid != item.uid)
          }
        })
      },
      resetUserPassword(user) {
        this.$confirm({
          color: 'warning',
          title: '确定重置该用户密码？',
          text: '重置密码后，会给用户生成一个新密码，用户只能使用新密码登录',
          accept: async () => {
            const password = Math.random().toString(36).substr(2)
            await this.$s.user.adminResetPassword({
              uid: user.uid,
              password,
            }).catch(err => {
              this.$notify({
                color: 'danger',
                "title": "重置失败",
                "text": err.status == 100122 ? "权限不足" : "",
              })
              throw err
            })
            setTimeout(() => {
              this.$message({
                color: 'success',
                text: `
              <p>成功重置用户密码，请保管好新密码</p><br />
              用户名: ${user.userName} <br />
              新密码: ${password} <br /><br />

              <i>该提示只显示这一次</i>
              `,
                title: '重置密码'
              })
            }, 200)
          }
        })
      },
    },
  }
</script>
<style scoped>
  .avatar {
    width: 100px;
  }
</style>